import apiRequest from "../utils/apiRequest";

const uploadAttachmentApi = async (formData) => {
    return await apiRequest(
        "upload-file",
        "post",
        formData,
        {
            "Content-Type": "multipart/form-data"
        }
    );
};

export default uploadAttachmentApi;
